import SetUpMetaMaskWallet from "../../layouts/Learn/SetUpMetaMaskWallet";
import FindMetaMaskWithNFT from "../../layouts/Learn/FindMetaMaskWithNFT";
import FindNFTYouLove from "../../layouts/Learn/FindNFTYouLove";

import {
    Routes,
    Route,
  } from "react-router-dom";

const LearnPage = () => {
    return(
        <Routes>
            <Route path="how-to-easily-setup-a-metamask-wallet" element={<SetUpMetaMaskWallet />} />
            <Route path="how-to-fund-metamask-with-eth" element={<FindMetaMaskWithNFT />} />
            <Route path="how-to-find-an-nft-you-love" element={<FindNFTYouLove />} />
        </Routes>
    )
}

export default LearnPage;